import { FiHelpCircle } from '@react-icons/all-files/fi/FiHelpCircle';
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Button } from 'reactstrap';
import { SupplierMenu } from '../SupplierMenu';
import './styles.scss';

type SidebarProps = {};

const Sidebar: React.FC<SidebarProps> = () => {
  return (
    <div className="supplier-sidebar">
      <SupplierMenu />
      <div
        className="mt-4"
        style={{
          position: 'sticky',
          bottom: 0,
        }}
      >
        <a
          href="https://lp.orosy.com/apparel_brand_FAQ/"
          target="_blank"
          rel="noreferrer"
        >
          <Button outline className="rounded-pill" block>
            <FiHelpCircle className="mr-2" />
            ヘルプページ
          </Button>
        </a>
      </div>
    </div>
  );
};

export default Sidebar;
